export default async function checkAPI ( { next } ) {
    /*
    await axios.get(`${process.env.VUE_APP_API}/utils/checkHealth`).then(
        (response) => {
            if(response.status === 200) {
                next();
            } else {
                throw true;
            }
        }
    ).catch((error) => {
        if(error) {
            router.push("/serverError")
            next();
        }
    });
    */
    return next()
}
